import { TYPES } from "../actions";

const initialState = {
  trustedBankVisas: [],
  totalCount: 0,
  currentVisa: null,
  searchResults: [],
  loading: false
};

export const tkt1TrustedBankVisaReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISAS_SUCCESS:
      return { 
        ...state, 
        trustedBankVisas: action.payload.data.data, 
        totalCount: action.payload.data.pagination ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISAS_FAIL:
      return { 
        ...state, 
        trustedBankVisas: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentVisa: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_FAIL:
      return { 
        ...state, 
        currentVisa: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_SUCCESS:
      return { 
        ...state, 
        currentVisa: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_FAIL:
      return { 
        ...state, 
        currentVisa: null,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_SUCCESS:
      return { 
        ...state, 
        searchResults: action.payload.data.data || action.payload.data,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_FAIL:
      return { 
        ...state, 
        searchResults: [],
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_SUCCESS:
      return { 
        ...state, 
        trustedBankVisas: [action.payload.data, ...state.trustedBankVisas],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_SUCCESS:
      return { 
        ...state, 
        trustedBankVisas: state.trustedBankVisas.map(visa => 
          visa._id === action.payload.data._id ? action.payload.data : visa
        ),
        currentVisa: state.currentVisa && state.currentVisa._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentVisa,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_SUCCESS:
      return { 
        ...state, 
        trustedBankVisas: state.trustedBankVisas.filter(visa => visa._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentVisa: state.currentVisa && state.currentVisa._id === action.payload.id 
          ? null 
          : state.currentVisa,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
